<template>

  <div
    v-if="licensed"
    class="
      complectation
      flex flex-col
      justify-between
      fixed
      h-full
      bg-white
    "
  >
    <div class="complectation__header">
      <div class="complectation__title">{{$t('client.complectation.title')}}:</div>
      <button
        @click="$emit('close')"
        class="complectation__close"
      ><img src="/images/design/close-configuration.svg"></button>
    </div>
    <div class="client-content flex-1 overflow-x-hidden complectation__content">

      <div class="elements">
        <div
          v-if="plot"
          class="text-xl mb-4"
        >
          {{ plot.name }}
        </div>
        <div
          class="element-item-list"
          v-if="elements.length"
        >
          <CardElementCart
            v-for="element in elements"
            :key="`complectation-element-${element.element_id}-${element.size&&element.size.element_size_id}-${element.material&&element.material.material_id}`"
            :id="`complectation-element-${element.element_id}`"
            :element="element"
            :settings="settings"
            :isComplectation="true"
          />

        </div>
        <div
          v-if="barrier"
          class="text-xl mb-4 border-blue-top"
        >
          <div class="element-item-list">
            <CardBarrierCart
              :barrier="barrier"
              :settings="settings"
              :isComplectation="true"
            />
          </div>
        </div>

        <CardLandscapingCart
          v-if="landscaping&&(landscaping.borderElement||landscaping.facing_side||landscaping.facing_top||landscaping.fillElement||landscaping.fillType||landscaping.mainElement)"
          class="mt-8"
          :landscaping="landscaping"
          :settings="settings"
          :isComplectation="true"
        />

        <CardEngravingCart
          v-if="faces && faces.length"
          class="mt-12 mb-4 border-blue-top"
          :faces="faces"
          :settings="settings"
          :isComplectation="true"
        />
      </div>
    </div>

    <div
      class="total text-white"
      style="background-color: #223644"
    >
      <div
        class="flex items-center justify-between"
        v-if="settings.with_calc_price == 1"
      >
        <div>
          <span
            style="color: #f5eab8"
            class="text-itogo text-sm"
          >{{$t('client.complectation.cost_orientir')}}</span>
        </div>
        <div class="
            text-right
            complectation__total">
          <InformerApproximatePrice additionalClass="rb" />
          <span>{{ $toCurrency(total) }}</span>
        </div>
      </div>
      <div v-else>{{$t('client.complectation.cost_manager')}}</div>
      <div
        v-if="$route.query.order_cache"
        class="mt-4 gap-4 grid grid-flow-col"
      >
        <!-- <order-scenes style="position: absolute; left: -9999px;" /> -->
        <router-link
          class=" bg-red-500 py-1 px-2 text-center"
          :to="{name: 'order_detail', params: {order_id: this.orderIdFromCache}}"
        >Вернуться в заказ</router-link>
        <button
          @click="goToConfirm"
          :disabled="!changed"
          :class="{'py-1 px-2 text-center bg-green-500 cursor-pointer border-none':changed, 'cursor-default border-solid border border-gray-600': !changed}"
        >Пересохранить</button>

      </div>
      <div
        v-else
        class="mt-4"
      >
        <router-link
          v-if="elements.length||landscaping.mainElement||barrier"
          :to="{name: 'Confirm'}"
          class="flex items-center w-full justify-between py-1 px-2 button__confirm"
        >
          <span class="flex-1 text-center">{{$t('client.complectation.confirm_order')}}</span>
          <span class="px-2"><i class="fas fa-angle-right"></i></span>
        </router-link>
      </div>
    </div>
  </div>

  <div
    v-else
    class="
      complectation
      w-4/12
      flex flex-col
      justify-between
      fixed
      h-full
      bg-white
    "
  >
    <div class="client-content">
      <div class="flex justify-between items-center mb-4">
        <div class="font-bold">{{$t('client.complectation.title')}}:</div>
        <button @click="$emit('close')"><i class="fas fa-times"></i></button>
      </div>
    </div>
    <div class="not-licensed">
      {{$t('main.demo_text')}}
    </div>
  </div>

</template>
<script>
import CardBarrierCart from "../General/CardBarrierCart.vue";
import CardElementCart from "../General/CardElementCart.vue";
import CardLandscapingCart from "../General/CardLandscapingCart.vue";
import CardEngravingCart from "../General/CardEngravingCart.vue";

export default {
  components: {
    CardElementCart,
    CardBarrierCart,
    CardLandscapingCart,
    CardEngravingCart,
  },
  name: "Complectation",
  data() {
    return {
      elementsCard: [],
    };
  },
  methods: {
    goToConfirm() {
      let route = { name: "Confirm" };
      if (this.$route.query && this.$route.query.order_cache) {
        route = {
          ...route,
          query: { order_cache: this.$route.query.order_cache },
        };
      }
      this.$router.push(route);
    },
  },

  computed: {
    changed() {
      return this.$store.state.clientOrder.changed;
    },
    licensed() {
      return this.$store.getters["licensed"];
    },
    orderIdFromCache() {
      return this.$store.getters["clientOrder/orderIdFromCache"];
    },
    settings() {
      return this.$store.state.settings.settings;
    },
    plot() {
      return this.$store.state.clientOrder.plot;
    },
    elements() {
      return this.$store.state.clientOrder.elements;
    },
    weight() {
      return this.$store.state.clientOrder.weight;
    },
    total() {
      return this.$store.state.clientOrder.total;
    },
    barrier() {
      return this.$store.state.clientOrder.barrier;
    },
    faces() {
      return this.$store.state.clientOrder.faces.filter(
        (f) => f.elements.length > 0 || f.texts.length > 0
      );
    },
    landscaping() {
      return this.$store.state.clientOrder.landscaping;
    },
  },
};
</script>
<style scoped>
.complectation {
  width: 33%;
  max-width: 560px;
  z-index: 2;
}
.not-licensed {
  width: 80%;
  margin: auto;
  color: #ff0000;
}
.total {
  padding: 20px 28px;
}
.complectation__header {
  height: 55px;
  background-color: #223644;
  color: #fff;
  display: flex;
  justify-content: space-between;
  padding-left: 28px;
  align-items: center;
}
.complectation__title {
  font-weight: 600;
}
.complectation__close {
  width: 50px;
  height: 100%;
  background-color: #c31818;
  display: grid;
  place-content: center;
}
.button__confirm {
  border: 1px #44677f solid;
}
.button__confirm:hover {
  background-color: #02a16b;
  border-color: #04483b;
}
.complectation__total {
  font-size: 30px;
  display: flex;
  align-items: center;
  column-gap: 20px;
}
.element-detail {
  display: flex;
  gap: 1rem;
}

@media screen and (max-width: 1000px) {
  .complectation {
    width: 300px;
    max-width: 300px;
  }
  .text-itogo {
    display: none;
  }
  .complectation__header {
    height: 40px;
  }
}
</style>
